import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { StyledTooltip, TooltipTitle } from './styles';
import { getUrls } from '../../../../utils/url';
import { StyledActionButton } from '../../styles/table-styles';

interface CopyUrlProps {
    classUuid: string;
}

const CopyUrlButton: React.FC<CopyUrlProps> = ({ classUuid }) => {
    const { t } = useTranslation('portal');

    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

    let timeout: ReturnType<typeof setTimeout>;

    const onCopyURL = () => {
        clearTimeout(timeout);

        const { vanityUrl } = getUrls();
        const classLink = `${vanityUrl}/class/${classUuid}`;

        navigator.clipboard.writeText(classLink);

        setTooltipIsOpen(true);

        timeout = setTimeout(() => {
            setTooltipIsOpen(false);
        }, 3000);
    };

    return (
        <StyledActionButton variant="outlined" onClick={() => onCopyURL()}>
            <StyledTooltip arrow open={tooltipIsOpen} title={<TooltipTitle>{t('classes-page.copied')}</TooltipTitle>}>
                <span>{t('classes-page.copy-url')}</span>
            </StyledTooltip>
        </StyledActionButton>
    );
};

export default CopyUrlButton;
